import React, {useState, useEffect} from 'react'
import { Container, Row, Col } from 'react-bootstrap';
import Show from './Show';
import './Show.scss';
import { useStateValue } from '../../../utilities/StateProvider';
import Cooler from './Cooler';
import { api } from '../../../utilities/fetch';

export default function ShowList() {

    const [ shows, setShows ] = useState([]);
    const [ cooler, setCooler ] = useState(null);
    const [ modal, setModal ] = useState(false);
    const [{ cart }, dispatch] = useStateValue();

    useEffect(() => {
        const getShows = async () => {
            const showList = await api.get(`shows`);
            setShows(showList.data);
        }
        getShows();
    }, [])

    const toggleModal = () => {
        setModal(false);
    }

    const updateCooler = (value) => {
        const { show } = cart;

        setCooler(value);
        const newCart = {
            ...cart,
            show: {
                ...show,
                cooler: value
            }
        }

        sessionStorage.setItem('cart', JSON.stringify(newCart));

        dispatch({
            type: 'setCart',
            cart: newCart
        });
    }

    const renderShows = () => {
        shows.sort((a, b) => (a.id - b.id));
        return (
            shows.map((entry, index) => (<Col xs="6" md="3" key={index} className="show-container"><Show data={entry} setModal={setModal}/></Col>))
        )
    }

    return (
        <Container>
            <Row>
                {renderShows()}
            </Row>
            <Cooler show={modal} submitCooler={updateCooler} onHide={toggleModal} defaultValue={cooler}/>
        </Container>
    )
}
